import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';

export interface AnswerListState {
    answers: any;
}

const initialState: AnswerListState = {
    answers: {},
};

export const answerListSlice = createSlice({
    name: 'answerList',
    initialState,
    reducers: {
        pushAnswer: (state, action) => {
            state["answers"][action.payload.id] = action.payload.value;
        },
        setValues: (state, action) => {
            state["answers"][action.payload.id]["values"] = action.payload.value;
        },
        setOtherInfo: (state, action) => {
            state["answers"][action.payload.id]["otherInfo"] = action.payload.value;
        },
        updateValue: (state, action) => {
            state["answers"][action.payload.id]["values"][action.payload.index] = action.payload.value;
        },
        replaceAllAnswers: (state, action: PayloadAction<Record<string, any>>) => {
            state.answers = action.payload;
        },
    },
});

export const { pushAnswer, setValues, setOtherInfo, updateValue, replaceAllAnswers } = answerListSlice.actions;

export const selectAnswers = (state: RootState) => state.answerList.answers;
export const selectAnswerById = (id: number | undefined) => (state: RootState) =>
    id !== undefined ? state.answerList.answers[id] : undefined;

export default answerListSlice.reducer;